export default __webpack_public_path__ + "static/media/microsoft.9eb561c5.svg";